import React from 'react';
import { components } from 'react-select';
import type { OptionProps, OptionTypeBase } from 'react-select';
import type { AllColorType, AllIconType } from '../../../util/types';
import { getIconComponent } from '../../../util/reactFunc';

const CustomOptionWithIcon: React.FC<OptionProps<OptionTypeBase, false> & {
  icon?: AllIconType,
  size?: number,
  color?: AllColorType,
  align?: 'left' | 'right',
  persistColor?: boolean
}> = ({
  ...props
}) => {

  const size = props?.size ?? 20;
  const align = props?.align ?? 'right';
  return (
    <components.Option data-cy="custom-option-parent" {...props}>
      <div className={`flex ${align === 'left' ? 'flex-row-reverse justify-end' : 'justify-between'} items-center`} data-cy="custom-option">
        <div className={'text-left'}>{props.children}</div>
        { props.icon && <div className={align === 'left' ? 'mr-sm' : 'ml-sm'}>
          {getIconComponent(props.icon, size, props?.color, props?.persistColor)}
        </div> }
      </div>
    </components.Option>
  );
};

export default CustomOptionWithIcon;
